(() => {
  'use strict';

  if (customElements.get('nuora-gr-v3-header')) return;

  class NuoraGrV3Header extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-nuora-header-drawer]');
      this.toggle = this.drawer?.querySelector(':scope > summary');
      if (!this.drawer || !this.toggle) return;

      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.drawer.addEventListener('toggle', this.onToggle);
      document.addEventListener('keydown', this.onKeydown);
      this.onToggle();
    }

    disconnectedCallback() {
      this.drawer?.removeEventListener('toggle', this.onToggle);
      document.removeEventListener('keydown', this.onKeydown);
      document.body.classList.remove('nuora-gr-v3-menu-open');
    }

    onToggle() {
      const isOpen = this.drawer.open;
      this.toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('nuora-gr-v3-menu-open', isOpen);
    }

    onKeydown(event) {
      if (event.key !== 'Escape' || !this.drawer.open) return;
      this.drawer.open = false;
      this.toggle.focus();
    }
  }

  customElements.define('nuora-gr-v3-header', NuoraGrV3Header);
})();
